module.exports = __webpack_public_path__ + "img/mobile-b.svg";